import React, { ReactElement, useEffect, useRef, FC } from 'react'
import './style.scss'
interface Props {
  maxValue: number
  value: number
  color: string
}
export const ProgressBar: FC<Props> = ({
  value,
  maxValue,
  color
}): ReactElement => {
  return (
    <div className='progress-bar'>
      <div
        style={{
          backgroundColor: color,
          width: (value / maxValue) * 100 + '%'
        }}
      />
    </div>
  )
}
